module.exports = __webpack_public_path__ + "images/pflegegrad2.svg?0ca0d13dcaa25a745d420d16c821bd5a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pflegegrad2.svg
// module id = 8kd9
// module chunks = 0